import { defineStore } from "pinia";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    isAuthorized: false,
    user: null,
    isRegistered: false,
    userRegData: {},
    email: null,
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
  },
});

export default useUserStore;
